<template>
  <article
    v-if="data"
    :class="{
      'container mx-auto grid gap-2 py-7 text-www-color-neutral-medium-dark lg:px-36': true,
    }"
  >
    <div
      :class="{
        'flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between': true,
      }"
    >
      <span
        :class="{
          'text-12px font-semibold text-www-color-accent-blue-dark': true,
        }"
      >
        {{ formatDateUTC(data.articleDate, 'MM/DD/YYYY') }}
      </span>
      <div
        :class="{
          'max-w-400px': true,
        }"
      >
        <Taxonomies
          :taxonomies="data.taxonomies"
          variant="inline"
          link-type="link"
          content-type="videos"
          :class="{
            'text-www-color-accent-blue-dark': true,
          }"
        />
      </div>
    </div>

    <h1
      :class="{
        'my-7 text-5xl font-medium text-www-color-accent-blue-dark': true,
      }"
    >
      {{ data.title }}
    </h1>

    <div
      v-if="data.person && data.person.length"
      :class="{
        'flex flex-wrap gap-2 lg:justify-end': true,
      }"
    >
      <template
        v-for="author in data.person"
        :key="author.reference?._id"
      >
        <Person
          v-if="author.reference"
          v-bind="author.reference"
        />
      </template>
    </div>

    <div
      v-if="data.content.videoPortableText && data.content.videoPortableText?.length !== 0"
      :class="{
        'mt-16': true,
      }"
    >
      <h2
        :class="{
          'mb-7 border-b border-www-color-black pb-1 font-semibold text-www-color-primary-lighter': true,
        }"
      >
        <!-- TODO Get Value From Sanity -->
        Description
      </h2>

      <PortableText :portable-data="data.content.videoPortableText" />
    </div>

    <div
      v-if="!data.hideTranscript && hasTranscript && data.wistiaVideoEmbed?.[0]"
      :class="{
        'mt-[28px] rounded-10px bg-www-color-neutral-very-light p-30px': true,
      }"
    >
      <h2
        class="mb-7 border-b border-www-color-primary-lighter pb-1 font-semibold capitalize text-www-color-black"
      >
        {{ data.transcriptTitle }}
      </h2>

      <p
        id="transcript"
        :class="{
          'max-h-[550px] overflow-y-auto font-light': true,
        }"
      >
        <wistia-transcript :media-id="data.wistiaVideoEmbed[0].hashed_id"></wistia-transcript>
      </p>
    </div>
  </article>
</template>

<script lang="ts" setup>
import Person from '~/components/Atoms/Person/Person.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import Taxonomies from '~/components/Atoms/Taxonomies/Taxonomies.vue';
import type { QueryVideoResult } from '~/sanity/types';
interface Props {
  data: QueryVideoResult;
}
const { data } = defineProps<Props>();
const hasTranscript = ref(false);

onMounted(async () => {
  const videoId = data?.wistiaVideoEmbed?.[0]?.hashed_id;
  if (!videoId) return;
  const response = await fetch(`https://fast.wistia.com/embed/medias/${videoId}.json`);
  const result = await response.json();
  hasTranscript.value = result.media.captions ? true : false;
});
</script>
